<template>
  <div class="c-card">
    <Button type="primary" @click="$emit('on-select')" v-if="!urls.length">选择{{ title }}</Button>
    <div class="list" v-else>
      <el-button class="reset" type="text" @click="$emit('on-select')" v-if="selectable">重新选择</el-button>
      <div class="item" v-for="(url, index) in urls" :key="url.accountId" :class="{ 'last-item': index === urls.length - 1 }">
        <Tooltip :content="url.row.name" placement="top-start" trigger="hover" max-width="400" transfer>
          <span class="url-name">{{ url.row.name }}</span>
        </Tooltip>
        <br />
        <span class="url-id">ID：{{ url.row.siteId }}</span>
        <Tooltip :content="url.accountName" placement="top-start" trigger="hover" max-width="400" style="float: right" transfer>
          <span class="account-name">账号：{{ url.accountName }}</span>
        </Tooltip>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PageSelect',
  props: {
    value: {
      type: String
    },
    urls: {
      type: Array,
      default() {
        return []
      }
    },
    accounts: {
      type: Array,
      default() {
        return []
      }
    },
    selectable: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: 'chengzi'
    }
  },
  computed: {
    title() {
      let t
      switch (this.type) {
        case 'chengzi':
          t = '推广内容'
          break
        case 'kuaishou':
          t = '快手建站落地页'
          break
        case 'asset':
          t = '自研落地页'
          break
      }
      return t
    }
  },
  data() {
    return {
      modal: false
    }
  },
  methods: {
    beforeUpload() {}
  }
}
</script>
<style lang="scss" scoped>
.c-card {
  position: relative;

  .list {
    width: 400px;
    max-height: 300px;
    border: 1px solid #d5d5d5;
    position: relative;
    overflow-y: auto;

    .reset {
      position: absolute;
      right: 0;
      top: 0;
      margin: 10px;
      padding: 0;
      font-size: 12px;
    }

    .item {
      height: 64px;
      padding: 10px;
      border-bottom: 1px solid #d5d5d5;

      span {
        display: inline-block;
        margin: 3px;
        padding: 1px;
      }

      .url-name {
        display: block;
        color: #2d8cf0;
        max-width: 320px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 14px;
      }

      .account-name {
        float: right;
        max-width: 180px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }

    .last-item {
      border: 0;
    }
  }
}
</style>
